import { render, staticRenderFns } from "./AnalyticsTab.vue?vue&type=template&id=9ba8c962&scoped=true&"
import script from "./AnalyticsTab.vue?vue&type=script&setup=true&lang=js&"
export * from "./AnalyticsTab.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./AnalyticsTab.vue?vue&type=style&index=0&id=9ba8c962&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ba8c962",
  null
  
)

export default component.exports